(() => {
  'use strict';

  const API = 'https://app.btime.om';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const isArabic = () => document.documentElement.lang?.toLowerCase().startsWith('ar');
  const productId = (value) => String(value || '').replace(/\D/g, '');

  async function request(url, timeout = 6500) {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), timeout);
    try {
      return await fetch(url, { headers: { Accept: 'application/json' }, signal: controller.signal });
    } finally {
      window.clearTimeout(timer);
    }
  }

  function render(element, rating = 0, count = 0) {
    if (!element) return;
    const normalizedRating = Math.max(0, Math.min(5, Number(rating) || 0));
    const normalizedCount = Math.max(0, Number(count) || 0);
    element.classList.remove('is-loading');
    element.classList.toggle('bt-no-reviews', normalizedCount === 0);

    const link = element.closest('.bt-product-rating-link');
    if (link) link.hidden = normalizedCount === 0;

    $('.bt-stars-fill', element)?.style.setProperty('width', `${normalizedRating * 20}%`);
    const countElement = $('[data-bt-count]', element);
    if (countElement) countElement.textContent = normalizedCount ? `(${normalizedCount})` : '';

    element.setAttribute(
      'aria-label',
      isArabic()
        ? `${normalizedRating.toFixed(1)} من 5، ${normalizedCount} تقييم`
        : `${normalizedRating.toFixed(1)} of 5, ${normalizedCount} reviews`
    );
  }

  async function load(root = document) {
    const badges = $$('[data-bt-rating]', root).filter((element) => !element.dataset.btRatingLoaded);
    if (!badges.length) return;

    badges.forEach((element) => { element.dataset.btRatingLoaded = '1'; });
    const remoteBadges = badges.filter((element) => !(Number(element.dataset.count) > 0));
    badges.filter((element) => !remoteBadges.includes(element)).forEach((element) => {
      render(element, element.dataset.rating, element.dataset.count);
    });

    const ids = Array.from(new Set(remoteBadges.map((element) => productId(element.dataset.productId)).filter(Boolean)));
    if (!ids.length) {
      remoteBadges.forEach((element) => render(element));
      document.dispatchEvent(new CustomEvent('bt:ratings:updated'));
      return;
    }

    try {
      const response = await request(
        `${API}/api/bt-reviews/summary?productIds=${ids.join(',')}&lang=${isArabic() ? 'ar' : 'en'}`
      );
      if (!response.ok) throw new Error(`HTTP_${response.status}`);
      const payload = await response.json();
      const summaries = payload.summaries || payload.data || payload;
      remoteBadges.forEach((element) => {
        const id = productId(element.dataset.productId);
        const summary = summaries[id] || summaries[`gid://shopify/Product/${id}`] || {};
        render(element, summary.average || summary.rating, summary.count || summary.total);
      });
    } catch (_) {
      remoteBadges.forEach((element) => render(element));
    } finally {
      document.dispatchEvent(new CustomEvent('bt:ratings:updated', { detail: { productIds: ids } }));
    }
  }

  function schedule(root = document) {
    const run = () => load(root);
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 1600 });
    else window.setTimeout(run, 250);
  }

  window.BTReviewBadges = { load, render, schedule };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedule(), { once: true });
  } else {
    schedule();
  }

  ['products:update', 'shopify:section:load', 'quick-view:loaded'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const root = event.target?.querySelectorAll ? event.target : document;
      load(root);
    });
  });
})();
